import {ReactElement} from 'react';
import Text from '@frontend/ui-kit/Components/Text';
import Icon, {ICON_TYPES} from '@frontend/ui-kit/Components/Icon';
import Link from '@frontend/ui-kit/Components/Link';
import {gettext} from '../../../translationService';
import './index.scss';

const Footer = (): ReactElement => {
    return (
        <div className='product-info-footer'>
            <div className='product-info-footer-email'>
                <Icon type={ICON_TYPES.message} className='product-info-footer-email__icon'/>
                <Link href='mailto:groups@healthjoy.com' className='product-info-footer-email__link'>
                    groups@healthjoy.com
                </Link>
            </div>
            <div className='product-info-footer-powered-by'>
                <Text>{gettext('Powered by')} HealthJoy, LLC</Text>
            </div>
            <div className='product-info-footer-phone'>
                <Icon type={ICON_TYPES.phone} className='product-info-footer-phone__icon'/>
                <Link href='tel:(877) 500-3212' className='product-info-footer-phone__link'>
                    (877) 500-3212
                </Link>
            </div>
        </div>
    );
};

export {Footer as TestableFooter};
export default Footer;
